module.exports = __webpack_public_path__ + "img/sapienza-with-text.7d9a8b1e.png";